export const SUBMIT_AGENCY_SIGNUP_FORM = 'action.agencySignup.submit';
export const RESEND_AGENCY_EMAIL = 'action.agencySignup.resend-email';
export const CHECK_AGENCY_NAME = 'action.agencySignup.check-name';
export const SET_AGENCY_SIGNUP_STATUS = 'action.agencySignup.set.status';
export const SET_AGENCY_SIGNUP_IS_LOADING = 'action.agencySignup.set.is-loading';
export const SET_AGENCY_SIGNUP_EMAIL_SENT = 'action.agencySignup.set.email-sent';
export const SET_AGENCY_NAME_AVAILABLE = 'action.agencySignup.set.name-available';

export const submitAgencySignupForm = data => ({
    type: SUBMIT_AGENCY_SIGNUP_FORM,
    data,
});

export const resendAgencyConfirmationEmail = email => ({
    type: RESEND_AGENCY_EMAIL,
    data: { email },
});

export const checkAgencyName = (agencyName, email) => ({
    type: CHECK_AGENCY_NAME,
    agencyName,
    email,
});

export const setAgencySignupStatus = (status, errorCode) => ({
    type: SET_AGENCY_SIGNUP_STATUS,
    status,
    errorCode,
});

export const setAgencySignupIsLoading = isLoading => ({
    type: SET_AGENCY_SIGNUP_IS_LOADING,
    isLoading,
});

export const setAgencySignupEmailSent = emailSent => ({
    type: SET_AGENCY_SIGNUP_EMAIL_SENT,
    emailSent,
});

export const setAgencyNameAvailable = nameAvailable => ({
    type: SET_AGENCY_NAME_AVAILABLE,
    nameAvailable,
});
